import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { formatDate } from 'date-fns'
import { toast } from 'sonner'

export default function useRemoveVaultFromGroup({
  // setError = null,
  // clientServerFieldMapping = null,
} = {}) {
  const queryClient = useQueryClient()

  const action = async ({
    id,
    sortOrder,
  }: {
    id: string | number
    sortOrder: number
  }) => {
    const response = await httpClient.post(
      `/team/vault/${id}/remove-from-group`,
      { sort_order: sortOrder },
    )

    await httpClient.put(`team/vault/sort-order`, {
      id,
      entity_type: 'vaults',
      sort_order: sortOrder,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Removed from the group')
      queryClient.invalidateQueries({ queryKey: ['vault'] })
    },
    onError: (error, variables) =>
      toast.error(error?.response?.data?.message ?? 'An error occurred.'),

    // handleFormError({
    //   error,
    //   variables,
    //   setError,
    //   clientServerFieldMapping,
    // }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
